// removed by extract-text-webpack-plugin
module.exports = {"trade-news":"trade-news","trade-news-right-content":"trade-news-right-content","trade-news-left-content":"trade-news-left-content","product-image":"product-image","title-link":"title-link","description":"description","time":"time"};


//////////////////
// WEBPACK FOOTER
// ./components/partials/tradenews/style.scss
// module id = ./components/partials/tradenews/style.scss
// module chunks = 0